import React from 'react';

interface Category {
  id: string;
  label: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-12">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-3 rounded-full font-inter text-sm font-medium transition-all duration-300 ${
            activeCategory === category.id
              ? 'bg-primary text-primary-foreground shadow-sacred-md'
              : 'bg-surface text-foreground hover:bg-primary/10 hover:text-primary'
          }`}
        >
          {category.label}
          <span className="ml-2 opacity-70">({category.count})</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;